/**
 * 文件工具函数
 */
import {
  Web as WebIcon,
  PictureAsPdf as PdfIcon,
  Article as ArticleIcon,
  Slideshow as SlideshowIcon,
  TextSnippet as MarkdownIcon,
  Description as DescriptionIcon,
  InsertDriveFile as FileIcon,
} from '@mui/icons-material'

/**
 * 根据文件名获取文件类型
 */
export const getFileType = (fileName) => {
  const ext = fileName.split('.').pop().toLowerCase()
  if (ext === 'pdf') return 'pdf'
  if (['doc', 'docx'].includes(ext)) return 'word'
  if (['ppt', 'pptx'].includes(ext)) return 'ppt'
  if (['md', 'markdown'].includes(ext)) return 'markdown'
  if (ext === 'json') return 'json'
  if (['txt'].includes(ext)) return 'txt'
  return 'file'
}

/**
 * 根据文件类型获取对应的图标
 */
export const getFileIcon = (type) => {
  switch (type) {
    case 'url':
      return WebIcon
    case 'pdf':
      return PdfIcon
    case 'word':
      return ArticleIcon
    case 'ppt':
      return SlideshowIcon
    case 'markdown':
      return MarkdownIcon
    case 'json':
      return DescriptionIcon
    case 'txt':
      return FileIcon
    default:
      return FileIcon
  }
}

/**
 * 根据文件类型获取图标颜色（符合常见文件类型品牌色）
 */
export const getFileIconColor = (type) => {
  switch (type) {
    case 'url':
      return '#2196f3'   // 蓝色 - 链接
    case 'pdf':
      return '#e53935'   // 红色 - PDF
    case 'word':
      return '#2b579a'   // 深蓝 - Word
    case 'ppt':
      return '#d24726'   // 橙红 - PowerPoint
    case 'markdown':
      return '#083fa1'   // 深蓝 - Markdown
    case 'json':
      return '#f9a825'   // 琥珀色 - JSON
    case 'txt':
      return '#757575'   // 灰色 - 文本
    default:
      return undefined   // 继承主题色
  }
}
